import Vue from 'vue'
import Router from 'vue-router'

import { beforeEach } from './functions/beforeEach'
import { scrollBehavior } from './functions/scrollBehavior'

import indexRoutes from './modules/indexRoutes'

import SlideGen from '/src/pages/tech/SlideGen'

Vue.use(Router)

let routes = indexRoutes

if (process.env.NODE_ENV === 'development') {
  routes.push({
    path: '/slide',
    name: 'SlideRoute',
    component: SlideGen
  })
}

const router = new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return scrollBehavior(to, from, savedPosition)
  },
  routes
})

router.beforeEach((to, from, next) => { return beforeEach(to, from, next) })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js